import { defineMessages } from 'react-intl';

const messages = defineMessages({
  EmployeesInTeamX: "Employees in team '{team}'",
  CreateNewTeam: 'Create new team',
  DeleteTeam: 'Delete team',
  AddEmployee: 'Add employee',
  EmployeeXAddedToTeamX: "{employee} added to '{team}'",
  RemoveEmployeeFromTeam: 'Remove employee from team',
  RemoveEmployeeFromTeamMsg: "Are you sure you want to remove {employee} from '{team}?'",
  EmployeeXRemovedFromTeamX: "{employee} removed from '{team}'",
  ViewEmployeesInTeamX: "View employees in '{team}'",
  RemoveTeam: 'Remove team',
  RemoveTeamXMsg:
    "Are you sure you want to delete team '{team}'? All employees in this team will be unlinked.",
  AddTeamToOtherTeamX: "Add team to '{team}'",
  SelectATeamToViewItsEmployees: 'Select a team to view its employees.',
  EmployeeInheritedTeamExplanation:
    "This employee is a member of the parent team of '{team}' and is automatically included in this team.",
  Teams: 'Teams',
  RestructureTeams: 'Restructure teams',
  Save: 'Save',
  Cancel: 'Cancel',
  RestructureTeamsInfo:
    "Use drag and drop to restructure the teams above. \r\nDon't forget to click the save button afterwards.",
  Name: 'Name',
  Email: 'Email',
  CanViewInvoices: 'Can view invoices?',
  TeamsSetByCompany: 'Teams set by company',
  TeamAlsoAssignedToUser:
    'Also assigned to user directly, the user will keep access if company teams change',
});

export default messages;
